import React from 'react';
import Button from 'components/common/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileDownload, faFileArchive } from '@fortawesome/pro-solid-svg-icons';
import { downloadSvg } from 'api/utils';
import store from 'store';
import DevModalButton from 'components/modal/DevModalButton';
import { addTextArrToTextObjects, addImagemagickToImages } from 'actions/scene';
import './Dev.scss';
import { storeGetState } from 'utils/utils';
import SceneHelper from 'utils/SceneHelper';

const filterAssetsByImageIds = (assets = [], imageIds = []) => {
  const imageIdsSet = new Set(imageIds);
  return assets
    .filter((asset) => imageIdsSet.has(asset.id))
    .map(({ id, src, originalSrc }) => ({ id, src, originalSrc }));
};

const getCurrentDesignId = (storeState) => {
  const idFromStore = storeState?.app?.canvasId;
  if (idFromStore !== undefined && idFromStore !== null && idFromStore !== '') {
    return idFromStore;
  }
  return new URLSearchParams(window.location.search).get('id');
};

const downloadJson = (data, fileName) => {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  const URLApi = window.URL || window.webkitURL;
  const url = URLApi.createObjectURL(blob);

  const a = document.createElement('a');
  a.download = fileName;
  a.type = 'application/json';
  a.href = url;
  a.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
  setTimeout(() => URLApi.revokeObjectURL(url), 0);
};

const getMockDesignData = (storeState, id) => {
  const { scene, photos: { photos = [], backgrounds = [], clipart = [] } = {} } = storeState;
  const imageIds = SceneHelper.getAllImageIds(storeState);

  const normalizedId = Number.isNaN(Number(id)) ? id : Number(id);
  return {
    id: normalizedId,
    type: 2,
    category_id: scene?.config?.categoryId || null,
    product_id: scene?.config?.productId || null,
    productoption_id: scene?.config?.productOptionId || null,
    size_id: 0,
    theme_id: null,
    name: 'Design',
    scene: {
      ...scene,
      assets: {
        photos: filterAssetsByImageIds(photos, imageIds),
        backgrounds: filterAssetsByImageIds(backgrounds, imageIds),
        clipart: filterAssetsByImageIds(clipart, imageIds),
      },
    },
  };
};

const DownloadSVGButton = ({ download, onlyCurrentPage }) => {
  const handleSave = React.useCallback(() => {
    store.dispatch(addTextArrToTextObjects());
    downloadSvg(storeGetState().scene, download, { renderMask: true, onlyCurrentPage });
  }, [download, onlyCurrentPage]);
  return (
    <Button onClick={handleSave} className="download-button" data-for="bottomTooltip" data-tip="[DEV] Download SVGs">
      <FontAwesomeIcon.Memo icon={onlyCurrentPage ? faFileDownload : faFileArchive} />
    </Button>
  );
};

const DownloadDesignDataButton = () => {
  const handleSave = React.useCallback(() => {
    store.dispatch(addTextArrToTextObjects());
    store.dispatch(addImagemagickToImages());
    const storeState = storeGetState();
    const id = getCurrentDesignId(storeState);
    if (!id) {
      console.warn('[DEV] Cannot export design JSON because id is missing in URL/store.');
      return;
    }
    const payload = getMockDesignData(storeState, id);
    downloadJson(payload, `${id}.json`);
  }, []);

  return (
    <Button
      onClick={handleSave}
      className="download-button"
      data-for="bottomTooltip"
      data-tip="[DEV] Download /design/:id mock JSON"
    >
      JSON
    </Button>
  );
};

const Dev = ({ desktop, showTitleOnDesktop, title }) => (
  <div className="dev-tab">
    {desktop && showTitleOnDesktop ? <h2>{title}</h2> : null}
    <DownloadSVGButton download onlyCurrentPage />
    <DevModalButton />
    <DownloadDesignDataButton />
    <DownloadSVGButton download />
  </div>
);

export default Dev;
